import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import Query from "@/components/Query";
import QueryRateI from "@/components/query/RateI";
import QueryRateLevy from "@/components/query/RateLevy";
import QueryRateE from "@/components/query/RateE";
import QueryRules from "@/components/query/Rules";
import QueryHsCode from "@/components/query/HsCode";
import Laws from "@/components/Laws";
import LawsList from "@/components/laws/List";
import LawsShow from "@/components/laws/Show";
import News from "@/components/News";
import OnlineMessage from "@/components/OnlineMessage";
import OnlineMessageList from "@/components/OnlineMessage/List";

import NewsList from "@/components/news/List";
import NewsShow from "@/components/news/Show";

import onlineMessagShow from "@/components/OnlineMessage/Show";

import NoticeShow from "@/components/news/Show2";

import News2List from "@/components/news2/List";
import News2Show from "@/components/news2/Show";
import RcepClassRoom from "@/components/news2/ClassRoom";
import About from "@/components/About";
import FAQ from "@/components/Faq";
import FAQList from "@/components/faq/List";
import CodeDictQuery from "@/components/CodeDictQuery";
import CodeDictQueryList from "@/components/codeQuery/List";
import CiqHsQuery from "@/components/CiqHsQuery";
import CiqHsQueryList from "@/components/CiqHsQuery/List";
import ZMTariffQuery from "@/components/ZMTariffQuery";
import ZMTariffQueryList from "@/components/zmTariffQuery/List";
import ExpertService from "@/components/ExpertService";
import NotFound from "@/components/layout/NotFound";
import My from "@/components/My";
import MyAccount from "@/components/member/MyAccount";
import Recharge from "@/components/member/Recharge";
import RechargeState from "@/components/member/RechargeState";
import RechargeHistory from "@/components/member/RechargeHistory";
import MyIntegral from "@/components/member/MyIntegral";
import MyInvoice from "@/components/member/MyInvoice";
import Channel from "@/components/Channel";
import RulesDecide from "@/components/RulesDecide";
import RulesDecideGuide from "@/components/RulesDecide/Guide";
import RulesDecideInvoice from "@/components/RulesDecide/Invoice";
import InvoiceMaterialShow from "@/components/RulesDecide/Show";
import InvoiceMaterialAdd from "@/components/RulesDecide/Add";
import InvoiceMaterialEdit from "@/components/RulesDecide/Edit";
import RulesDecideVote from "@/components/RulesDecide/Vote";
import RulesDecideVoteResult from "@/components/RulesDecide/Result";
import RulesDecideCertList from "@/components/RulesDecide/Cert";
import RulesDecideCertDetail from "@/components/RulesDecide/CertDetail";
import RulesDecideCertCreate from "@/components/RulesDecide/CertCreate";
import BatchQuery from "@/components/BatchQuery";
import Enjoy from "@/components/Enjoy";
import Classify from "@/components/Classify";
import ClassifyList from "@/components/Classify/ClassifyList";
import ClassifyDetail from "@/components/Classify/ClassifyDetail";

import EnjoyDiscount from "@/components/Enjoy/Discount";
import EnjoyResult from "@/components/Enjoy/Result";
import NewService from "@/components/NewService";
import NewHelp from "@/components/Help";
import HelpPlatform from "@/components/help/Platform";
import HelpManual from "@/components/help/Manual";
import DataBoard from "@/components/help/DataBoard";
import OriginCert from "@/components/help/OriginCert";
import Mobile from "@/components/help/Mobile";
import DownList from "@/components/down/List";
import FtaList from "@/components/ftaList/List";
import AppExample from "@/components/appExampleList/List";

import DOWNShow from "@/components/down/Show";
Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: "nav.home"
      }
    },
    {
      path: "/login",
      name: "login",
      meta: {
        title: "Login - \u767b\u5f55",
        hidden: true
      },
      component: () => import("@/components/login/login.vue")
    },
    {
      path: "/reg",
      name: "reg",
      meta: {
        title: "Login - \u767b\u5f55",
        hidden: true
      },
      component: () => import("@/components/login/reg.vue")
    },
    {
      path: "/activation/:accountActivationCode",
      name: "activationAccount",
      component: Home,
      meta: {
        title: "nav.home"
      },
      props: true
    },
    {
      path: "/channel/:code",
      name: "Channel",
      component: Channel,
      meta: {
        title: "nav.home"
      },
      props: true
    },
    {
      path: "/batchquery",
      name: "BatchQuery",
      component: BatchQuery,
      meta: {
        title: "nav.home",
        requireAuth: true
      }
    },
    {
      path: "/resetpwd/:rstName/:rstCode",
      name: "RestAccountPassword",
      component: Home,
      meta: {
        title: "nav.home"
      },
      props: true
    },
    {
      path: "/my",
      component: My,
      children: [
        {
          name: "myAccount",
          meta: {
            title: "nav.myAccount",
            requireAuth: true
          },
          path: "",
          component: MyAccount
        },
        {
          name: "Recharge",
          meta: {
            title: "account.recharge.title",
            requireAuth: true
          },
          path: "recharge",
          component: Recharge
        },
        {
          name: "RechargeState",
          meta: {
            title: "account.recharge.stateTitle",
            requireAuth: true
          },
          path: "recharge/state/:id",
          component: RechargeState,
          props: true
        },
        {
          name: "RechargeHistory",
          meta: {
            title: "account.recharge.historyTitle",
            requireAuth: true
          },
          path: "recharge/history",
          component: RechargeHistory
        },
        {
          name: "MyIntegral",
          meta: {
            title: "account.integral.title",
            requireAuth: true
          },
          path: "integral",
          component: MyIntegral
        },
        {
          name: "MyInvoice",
          meta: {
            title: "account.invoice.title",
            requireAuth: true
          },
          path: "invoice",
          component: MyInvoice
        }
      ]
    },
    {
      path: "/query",
      component: Query,
      children: [
        //\u4e2d\u7f8e\u52a0\u5f81
        {
          name: "queryRateLevy",
          meta: {
            title: "\u4e2d\u7f8e\u52a0\u5f81"
          },
          path: "levy/:exporter/:importer/:hscode",
          component: QueryRateLevy,
          props: true
        },
        {
          name: "queryRateI",
          meta: {
            title: "query.type.rateI"
          },
          path: "rate/:exporter/:importer/:hscode",
          component: QueryRateI,
          props: true
        },
        {
          name: "queryRateE",
          meta: {
            title: "query.type.rateE"
          },
          path: "rateE/:exporter/:importer/:hscode",
          component: QueryRateE,
          props: true
        },
        {
          name: "queryRules",
          meta: {
            title: "query.type.rules"
          },
          path: "rules/:exporter/:importer/:hscode",
          component: QueryRules,
          props: true
        },
        {
          name: "queryHsCode",
          meta: {
            title: "query.type.hscode"
          },
          path: "hscode/:importer?/:hscode",
          component: QueryHsCode,
          props: true
        }
      ]
    },
    {
      path: "/enjoy/discount",
      component: Enjoy,
      children: [
        {
          name: "EnjoyDiscount",
          meta: {
            title: "enjoy.title"
            // requireAuth: true
          },
          path: "",
          component: EnjoyDiscount
        },
        {
          name: "EnjoyResult",
          meta: {
            title: "enjoy.title"
            // requireAuth: true
          },
          path: "show/:id",
          component: EnjoyResult,
          props: true
        }
      ]
    },
    {
      path: "/guide/coo",
      name: "RulesDecideGuide",
      component: RulesDecideGuide,
      meta: {
        title: "rulesDecide.title"
      }
    },
    {
      path: "/rules/decide",
      component: RulesDecide,
      children: [
        {
          name: "RulesDecide",
          meta: {
            title: "rulesDecide.title2"
            // requireAuth: true
          },
          path: "",
          component: RulesDecideInvoice
        },
        {
          name: "InvoiceMaterialShow",
          meta: {
            title: "rulesDecide.title",
            requireAuth: true
          },
          path: "show/:id",
          component: InvoiceMaterialShow,
          props: true
        },
        {
          name: "InvoiceMaterialAdd",
          meta: {
            title: "rulesDecide.title",
            requireAuth: true
          },
          path: "add",
          component: InvoiceMaterialAdd
        },
        {
          name: "InvoiceMaterialEdit",
          meta: {
            title: "rulesDecide.title",
            requireAuth: true
          },
          path: "edit/:id",
          component: InvoiceMaterialEdit,
          props: true
        },
        {
          name: "RulesDecideVote",
          meta: {
            title: "rulesDecide.title",
            requireAuth: true
          },
          path: "vote/:id",
          component: RulesDecideVote,
          props: true
        },

        {
          name: "RulesDecideVoteResult",
          meta: {
            title: "rulesDecide.title"
            // requireAuth: true
          },
          path: "vote/result/:id/:whollyObtained",
          component: RulesDecideVoteResult,
          props: true
        },
        {
          name: "RulesDecideCertList",
          meta: {
            title: "rulesDecide.title",
            requireAuth: true
          },
          path: "cert",
          component: RulesDecideCertList
        },
        {
          name: "RulesDecideCertDetail",
          meta: {
            title: "rulesDecide.title",
            requireAuth: true
          },
          path: "cert/:id",
          component: RulesDecideCertDetail,
          props: true
        },
        {
          name: "RulesDecideCertCreate",
          meta: {
            title: "rulesDecide.title",
            requireAuth: true
          },
          path: "create/cert",
          component: RulesDecideCertCreate
        }
      ]
    },
    {
      path: "/laws",
      component: Laws,
      children: [
        {
          name: "Laws",
          meta: {
            title: "nav.laws"
          },
          path: "",
          component: LawsList
        },
        {
          name: "LawsList",
          meta: {
            title: "nav.laws"
          },
          path: ":page/list",
          component: LawsList,
          props: true
        },
        {
          name: "LawsShow",
          meta: {
            title: "nav.laws"
          },
          path: "detail/:id",
          component: LawsShow,
          props: true
        }
      ]
    },
    {
      path: "/news",
      component: News,
      children: [
        {
          name: "News",
          meta: {
            title: "nav.news"
          },
          path: "",
          component: NewsList
        },
        {
          name: "NewsList",
          meta: {
            title: "nav.news"
          },
          path: ":page/list",
          component: NewsList,
          props: true
        },
        {
          name: "NewsShow",
          meta: {
            title: "nav.news"
          },
          path: "detail/:id",
          component: NewsShow,
          props: true
        },
        {
          name: "NoticeShow",
          meta: {
            title: "nav.notices"
          },
          path: "noticedetail/:id",
          component: NoticeShow,
          props: true
        }
      ]
    },
    {
      path: "/onlineMessage",
      component: OnlineMessage,
      children: [
        {
          name: "OnlineMessage",
          meta: {
            title: "\u5728\u7ebf\u7559\u8a00"
          },
          path: "",
          component: OnlineMessageList
        },
        {
          name: "onlineMessageList",
          meta: {
            title: "\u5728\u7ebf\u7559\u8a00"
          },
          path: ":page/list",
          component: OnlineMessageList,
          props: true
        },
        {
          name: "onlineMessagShow",
          meta: {
            title: "\u5728\u7ebf\u7559\u8a00\u8be6\u60c5"
          },
          path: "detail/:no",
          component: onlineMessagShow,
          props: true
        }
      ]
    },
    {
      path: "/service-center",
      component: NewHelp,
      children: [
        {
          name: "HelpPlatform",
          meta: { title: "nav.platform" },
          path: "platform",
          component: HelpPlatform
        },
        {
          name: "HelpManual",
          meta: { title: "nav.manual" },
          path: "manual",
          component: HelpManual
        },
        {
          name: "DataBoard",
          meta: { title: "nav.dataBoard" },
          path: "databoard",
          component: DataBoard
        },
        {
          name: "OriginCert",
          meta: { title: "nav.origincert" },
          path: "origincert",
          component: OriginCert
        },
        {
          name: "Mobile",
          meta: { title: "nav.mobile" },
          path: "mobile",
          component: Mobile
        }
      ]
    },

    {
      path: "/classify",
      component: Classify,
      children: [
        {
          name: "classify",
          meta: {
            title: "\u667a\u80fd\u5f52\u7c7b"
          },
          path: "classifylist",
          component: ClassifyList
        },
        {
          name: "classifydetail",
          meta: {
            title: "\u667a\u80fd\u5f52\u7c7b\u8be6\u60c5"
          },
          path: "detail",
          component: ClassifyDetail,
          props: true
        }
      ]
    },
    {
      path: "/rcep",
      component: News,
      children: [
        {
          name: "Rcep",
          meta: {
            title: "nav.rcep"
          },
          path: "",
          component: News2List
        },
        {
          name: "RcepClassroom",
          meta: {
            title: "nav.zxzj"
          },
          path: "classroom",
          component: RcepClassRoom
        },
        {
          name: "RcepList",
          meta: {
            title: "nav.rcep"
          },
          path: ":page/list",
          component: News2List,
          props: true
        },
        {
          name: "RcepShow",
          meta: {
            title: "nav.rcep"
          },
          path: "detail/:id",
          component: News2Show,
          props: true
        }
      ]
    },
    {
      path: "/about",
      name: "About",
      component: About,
      meta: {
        title: "nav.about"
      }
    },
    {
      path: "/faq",
      component: FAQ,
      children: [
        {
          name: "Faq",
          meta: {
            title: "nav.faq"
          },
          path: "",
          component: FAQList
        },
        {
          name: "FaqList",
          meta: {
            title: "nav.faq"
          },
          path: ":page/list",
          component: FAQList,
          props: true
        }
      ]
    },
    {
      path: "/zm-tariff-query",
      component: ZMTariffQuery,
      children: [
        {
          name: "zmAddTariffQuery",
          meta: {
            title: "query.result.other.zmAddTariffQuery"
          },
          path: "",
          component: ZMTariffQueryList
        }
      ]
    },
    {
      path: "/down",
      component: News,
      children: [
        {
          name: "Down",
          meta: {
            title: "\u534f\u5b9a\u6587\u672c"
          },
          path: "",
          component: DownList
        },

        {
          name: "DownListInfo",
          meta: { title: "\u534f\u5b9a\u6587\u672c\u8be6\u60c5" },
          path: "detail",
          component: DOWNShow
        }
      ]
    },
    {
      path: "/ftaList",
      component: News,
      children: [
        {
          name: "FtaList",
          meta: {
            title: "\u534f\u5b9a\u6587\u672c"
          },
          path: "",
          component: FtaList
        }
      ]
    },

    {
      path: "/appExample",
      component: News,
      children: [
        {
          name: "AppExample",
          meta: {
            title: "RCEP\u5e94\u7528\u5b9e\u4f8b"
          },
          path: "",
          component: AppExample
        }
      ]
    },

    {
      path: "/code-dict-query",
      component: CodeDictQuery,
      children: [
        {
          name: "CodeDictQuery",
          meta: {
            title: "query.result.other.codeDictQuery"
          },
          path: "",
          component: CodeDictQueryList
        }
      ]
    },
    {
      path: "/ciq-hs-query",
      component: CiqHsQuery,
      children: [
        {
          name: "CiqHsQuery",
          meta: {
            title: "query.result.other.ciqHSQuery"
          },
          path: "",
          component: CiqHsQueryList
        }
      ]
    },
    {
      name: "ExpertService",
      component: ExpertService,
      path: "/expert-help",
      meta: {
        title: "nav.expertService"
      }
    },
    {
      name: "NewService",
      component: NewService,
      path: "/service-help",
      meta: {
        title: "nav.newService"
      }
    },
    {
      path: "*",
      component: NotFound,
      meta: {
        title: "notfound"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js